import { useState } from "react";
import { Phone, Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import ScheduleVisitDialog from "@/components/ScheduleVisitDialog";
import { WHATSAPP_NUMBER } from "@/components/WhatsAppFloatingButton";
import logoTopclass from "@/assets/logo-topclass.jpg";
import { useLanguage } from "@/contexts/LanguageContext";

const Navbar = () => {
  const { language, setLanguage, t } = useLanguage();
  const [mobileOpen, setMobileOpen] = useState(false);
  const whatsappMsg = language === "pt" ? "Olá! Gostaria de mais informações." : "Hi! I'd like more information.";
  const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(whatsappMsg)}`;

  const links = [
    { href: "#buscar", label: t("nav.search"), title: "Buscar imóveis por bairro, quartos e preço" },
    { href: "#imoveis", label: t("nav.properties"), title: "Imóveis à venda no Rio de Janeiro" },
    { href: "/lancamentos", label: t("nav.launches"), highlight: true, title: "Lançamentos imobiliários no Rio de Janeiro" },
    { href: "/avaliacao", label: "Avaliação", title: "Avaliação gratuita do seu imóvel" },
    { href: "/anuncie-seu-imovel", label: "Anuncie", title: "Anuncie seu imóvel com a TopClass Imóveis" },
    { href: "/blog", label: "Blog", title: "Blog TopClass Imóveis: mercado imobiliário do Rio" },
    { href: "#contato", label: t("nav.contact"), title: "Fale com a TopClass Imóveis" },
  ];

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b border-border shadow-md">
      <div className="container mx-auto px-4 flex items-center justify-between h-16">
        <div className="flex items-center">
          <img src={logoTopclass} alt="Topclass Imobiliária Premium" className="h-14" />
        </div>

        <div className="hidden md:flex items-center gap-6 font-body text-sm text-foreground/70">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              title={l.title}
              className={`hover:text-accent transition-colors ${l.highlight ? "font-semibold text-accent" : ""}`}
            >
              {l.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-3">
          <div className="flex items-center gap-1">
            <button
              onClick={() => setLanguage("pt")}
              className={`text-xl leading-none rounded transition-opacity ${language === "pt" ? "opacity-100" : "opacity-40 hover:opacity-70"}`}
              aria-label="Português"
              title="Português"
            >
              🇧🇷
            </button>
            <button
              onClick={() => setLanguage("en")}
              className={`text-xl leading-none rounded transition-opacity ${language === "en" ? "opacity-100" : "opacity-40 hover:opacity-70"}`}
              aria-label="English"
              title="English"
            >
              🇺🇸
            </button>
          </div>
          <a href={`tel:+${WHATSAPP_NUMBER}`} title="Ligar para a TopClass Imóveis: +55 21 97354-8387" className="hidden sm:flex items-center gap-1 text-sm text-foreground/70 font-body">
            <Phone className="h-4 w-4" />
            +55 21 97354-8387
          </a>
          <ScheduleVisitDialog
            propertyName="Agendamento pelo menu do site"
            variant="gold"
            size="sm"
            label={t("nav.schedule")}
          />
          <button
            className="md:hidden p-1 text-foreground/70"
            onClick={() => setMobileOpen((o) => !o)}
            aria-label={mobileOpen ? "Fechar menu" : "Abrir menu"}
            aria-expanded={mobileOpen}
          >
            {mobileOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}

          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden border-t border-border bg-white/98 backdrop-blur-sm">
          <div className="container mx-auto px-4 py-3 flex flex-col font-body text-sm">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                title={l.title}
                onClick={() => setMobileOpen(false)}
                className={`py-2.5 border-b border-border/60 last:border-0 hover:text-accent transition-colors ${
                  l.highlight ? "font-semibold text-accent" : "text-foreground/80"
                }`}
              >
                {l.label}
              </a>
            ))}
            <a href={`tel:+${WHATSAPP_NUMBER}`} title="Ligar para a TopClass Imóveis: +55 21 97354-8387" className="py-2.5 flex items-center gap-2 text-foreground/80">
              <Phone className="h-4 w-4" /> +55 21 97354-8387
            </a>
            <div className="pt-2 pb-1">
              <ScheduleVisitDialog
                propertyName="Agendamento pelo menu mobile"
                variant="gold"
                size="sm"
                className="w-full"
                label={t("nav.schedule")}
              />
            </div>
          </div>
        </div>
      )}
    </nav>
  );

};

export default Navbar;
